import { useHistory } from 'react-router-dom';
import { useCompany } from './contexts/CompanyContext';
import { useConfig } from './contexts/ConfigContext';
import { useUser } from './contexts/UserContext';
import React, { useEffect } from 'react';
import useAuth from './hooks/useAuth';
import { Spin } from 'antd';
import { app } from './config/const';
import { contentPath, modules } from './config/pages';

const navOptions = [
  modules.StorageItemList,
  modules.RegisterStorageItem,
  modules.MovementList,
  modules.RegisterEntry,
  modules.PendingEntriesList,
  modules.RegisterExit,
  modules.PendingExitsList,
  modules.StockOverrideList,
  modules.StorageReports,
  modules.Traceability,
  modules.StoreList,
  modules.ContactList,
  modules.Settings,
];

function App(){
  const params = new URLSearchParams(window.location.search)
  const session = params.get('session') || ""
  const companyUid = params.get('company') || ""
  const {updateConfig} = useConfig()
  const {company,updateCompany} = useCompany()
  const {updateUser} = useUser()
  const history = useHistory()

  const fingerprint = "DEFUALT_FP"
  const {tokenData} = useAuth.useToken('authCsrfToken',session,null)
  const {data:baseData} = useAuth.useLoadBase(tokenData,{session,fingerprint,company: companyUid,module:"INICIO"})
  const {data:indexData} = useAuth.useIndex(tokenData,{
    session,
    company: companyUid,
    module: "INICIO"
  })

  useEffect(()=>{
    if(baseData && indexData?.user){
      updateConfig({
        showProgress: false,
        key:baseData.key || tokenData?.key,
        session,
        token: tokenData?.token?.uid
      })

      //permisos insuficientes
      if(baseData.status === 401 && baseData.redirect){
        window.location.href = baseData.redirect
        return
      }

      const defaultCompany = indexData.companies?.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Storage) && el.company_id === comp.id) &&
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Storage && mod.company_id === comp.id)
      ) ?? indexData.companies?.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Storage) && el.company_id === comp.id)
      ) ?? indexData.companies?.find((comp: any) => 
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Storage && mod.company_id === comp.id)
      ) ?? indexData.companies?.[0];

      const currentCompany = companyUid ? (indexData.companies?.find((comp: any) => comp.uid === companyUid) ?? defaultCompany) : defaultCompany;

      if(currentCompany){
        updateCompany({current:{...currentCompany, uid: currentCompany.uid || companyUid}})
      }

      const views: string[] = (indexData.permissions || [])
        .filter((el: any) => el.type === 'VIEW' && (!currentCompany || el.company_id === currentCompany.id))
        .map((el: any) => el.key);

      updateUser({
        ...indexData.user,
        permissions:{
          views,
          actions: (indexData.permissions || [])
            .filter((el: any) => el.type === 'ACTION' && (!currentCompany || el.company_id === currentCompany.id))
            .map((el: any) => el.key)
        },
        roles: indexData.permissions
      })

      const isDefaultAllowed = views.some(v => v.toLowerCase().includes(modules.StorageItemList.toLowerCase()));
      if (isDefaultAllowed) {
        history.push(contentPath[modules.StorageItemList]);
      } else {
        const firstAvailable = navOptions.find(key => views.some(v => v.toLowerCase().includes(key.toLowerCase())));
        if (firstAvailable) {
          history.push(contentPath[firstAvailable]);
        } else {
          history.push(contentPath[modules.StorageItemList]);
        }
      }
    }
  },[tokenData,baseData,indexData,companyUid,history,session])

  return(
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Spin size="large" tip="Cargando..."  fullscreen/>
    </div>
  )
}

export default App;
